import { ILookup } from '../api/dtos';

/**
 * Converts a lookup field string value to its corresponding numeric ID.
 * Returns undefined if the value is falsy or no matching item is found.
 */
export function getLookupIdFromValue(
    lookups: ILookup[] | undefined | null,
    fieldName: string,
    value: string | null | undefined
): number | undefined {
    if (!value) {
        return undefined;
    }

    const id = parseInt(String(lookups?.find(x => x.propertyName === fieldName)?.items?.find(item => item.value === value)?.id));
    return isNaN(id) ? 
        undefined : 
        id;
}

/**
 * Converts a lookup field ID to its corresponding string value.
 * Returns undefined if the id is falsy or no matching item is found.
 */
export function getLookupValueFromId(
    lookups: ILookup[] | undefined | null,
    fieldName: string,
    id: unknown
): string | undefined {
    if (!id && id !== 0) {
        return undefined;
    }

    return lookups?.find(x => x.propertyName === fieldName)?.items?.find(item => item.id === id)?.value as string | undefined;
}
